import { render, staticRenderFns } from "./forgot-password-reset.vue?vue&type=template&id=f4877c36&"
import script from "./forgot-password-reset.vue?vue&type=script&lang=js&"
export * from "./forgot-password-reset.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-reset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports